import { api } from "../Apis/interceptor";

export const create = function (PlanData) {
  return api.post("/api/v1/createPlan", PlanData);
};
export const getPlanDetails = function (plan_id) {
  return api.get("/api/v1/getPlanDetails/" + plan_id);
};
export const getModulePermissions = function (plan_id, module_name) {
  return api.get("/api/v1/getModulePermissions/" + plan_id + "/" + module_name);
};
export const getAllPlans = function () {
  return api.get("/api/v1/getAllPlans");
};
export const saveConfiguration = function (
  plan_id,
  configuartion,
  module_name
) {
  return api.put(
    "/api/v1/saveConfiguration/" + plan_id + "/" + module_name,
    configuartion
  );
};
export const updateConfiguration = function (
  plan_id,
  configuartion,
  module_name
) {
  return api.put(
    "/api/v1/updateConfiguration/" + plan_id + "/" + module_name,
    configuartion
  );
};
// export const refreshConfiguration = function(plan_id,configuartion,module_name) {
//     return api.put('/api/v1/refreshConfiguration/'+plan_id+"/"+module_name,configuartion);
// };
export const getOthersPermissions = function (plan_id, module_name) {
  return api.get("/api/v1/getOthersPermissions/" + plan_id + "/" + module_name);
};
export const saveOthersConfiguration = function (plan_id, configuartion) {
  return api.put("/api/v1/saveOthersConfiguration/" + plan_id, configuartion);
};
export const isFreeOrIndividual = function (plan_id) {
  return api.get("/api/v1/isFreeOrIndividual/" + plan_id);
};
